import {
  Heading,
  LiliButton,
  LiliButtonType,
  FontWeight,
  NavigationHeader,
} from '@lili/lili-frontend-common';
import { Trans, useTranslation } from 'react-i18next';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { MobileNavigationHeader } from '@Components/happyFlowTemplate/MobileNavigationHeader';
import { useMultiBusinessIntroLogic } from './useMultiBusinessIntroLogic';

const STEPS = ['step1', 'step2', 'step3'] as const;

const StepCard = ({ stepNumber, label }: { stepNumber: number; label: string }) => (
  <div className='flex flex-row sm:flex-col sm:flex-1 items-center sm:justify-center gap-[12px] sm:gap-[16px] rounded-[8px] bg-surface-purple-secondary p-[16px] sm:p-[24px] sm:h-[152px]'>
    <div className='flex size-[40px] shrink-0 items-center justify-center rounded-full border-[1.5px] border-outline-primary-bw-05'>
      <Heading.H9 className='text-text-main-tertiary'>{stepNumber}</Heading.H9>
    </div>
    <Heading.H10 className='sm:hidden flex-1'>{label}</Heading.H10>
    <Heading.H9 className='hidden sm:block text-center'>{label}</Heading.H9>
  </div>
);

export const MultiBusinessIntro = () => {
  const { t } = useTranslation();
  const { isPending, asyncGetStartData } = useMultiBusinessIntroLogic();

  return (
    <div className='flex flex-col w-full h-full items-center justify-between'>
      <NavigationHeader
        title={t('pages.multiBusinessIntro.title')}
        disableMarginBottom
        className='hidden sm:flex'
      />
      <MobileNavigationHeader />
      <div className='flex flex-col w-full h-full items-center justify-between pt-[56px] px-[24px] pb-[24px] sm:justify-center sm:p-0'>
        <div className='flex flex-col items-center w-full max-w-[400px] sm:max-w-[600px]'>
          <img src={logoUrl} alt='logo' className='hidden sm:block w-[48px] mb-[54px]' />
          <div className='flex flex-col gap-[32px] sm:gap-[40px] w-full'>
            <div className='flex flex-col gap-[8px] text-center w-full'>
              <Heading.H6
                className='sm:text-[28px] text-[22px] leading-[28px] sm:leading-[34px]'
                fontWeight={FontWeight.SEMIBOLD}>
                {t('pages.multiBusinessIntro.title')}
              </Heading.H6>
              <Heading.H10 className='sm:hidden leading-[20px]'>
                <Trans i18nKey='pages.multiBusinessIntro.bodyText' components={{ br: <></> }} />
              </Heading.H10>
              <Heading.H9 className='hidden sm:block'>
                <Trans i18nKey='pages.multiBusinessIntro.bodyText' components={{ br: <br /> }} />
              </Heading.H9>
            </div>
            <div className='flex flex-col sm:flex-row gap-[8px] w-full'>
              {STEPS.map((stepKey, index) => (
                <StepCard
                  key={stepKey}
                  stepNumber={index + 1}
                  label={t(`pages.multiBusinessIntro.${stepKey}`)}
                />
              ))}
            </div>
          </div>
        </div>
        <LiliButton
          className='max-w-[400px] sm:w-[295px] sm:mt-[54px]'
          isLoading={isPending}
          type={LiliButtonType.PRIMARY}
          title={t('pages.multiBusinessIntro.buttonText')}
          id='getStarted'
          onClick={() => asyncGetStartData()}
        />
      </div>
    </div>
  );
};
